import { useFormikContext } from "formik";
import { useEffect, useRef } from "react";
const ValidateFormOnParameterChange = ({ parameters }) => {
  const { validateForm } = useFormikContext();
  const mounted = useRef(false);
  useEffect(() => {
    if (mounted.current) {
      validateForm();
    } else {
      mounted.current = true;
    }
  }, [validateForm, parameters]);
  return null;
};
export default ValidateFormOnParameterChange;
